import React from 'react';
import AssetsCollectionScreen from 'components/AssetsCollectionScreen';
import * as Models from 'models';
import styles from './styles.module.scss';

type Props = {
  document: Models.AssetsCollectionMap;
  showScreenDetails(previewUrl: string): void;
  dataTestId?: string;
};

const AssetsCollectionScreens: React.FC<Props> = ({
  document,
  showScreenDetails,
  dataTestId = 'assetsCollectionScreens',
}) => {
  const entities = (document as Models.StoryCardMap).get('entities');
  const screens = entities?.get('screens');
  const screenIds = entities?.get('screenIds');
  if (!screens) {
    return null;
  }

  return (
    <ul className={styles.AssetsCollectionScreens} data-testid={dataTestId}>
      {screenIds?.toArray().map((screenId, index) => {
        const screen = screens.get(screenId);

        return (
          <li key={screenId} className={styles.item} data-testid={`${dataTestId}-item${String(index)}`}>
            <AssetsCollectionScreen
              document={document}
              screen={screen}
              screenOrder={index + 1}
              showDetails={showScreenDetails}
              dataTestId={`${dataTestId}-screen${String(index)}`}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default AssetsCollectionScreens;
